module.exports = __webpack_public_path__ + "static/media/Template_44.d4f4188b.png";